<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text Edit date and time
        v-spacer
        v-btn(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-4.pb-4
        div.p1.basic700--text Select pick up date and time
        div
          v-row.mt-4.mb-2(no-gutters)
            v-col.pr-1
              v-card.px-3.py-2(outlined :style="!dateTime ? `border:2px solid var(--v-info500)` : `border:2px solid var(--v-textColorHint)`" @click="dateTime = null; showPicker = false")
                div.button-AA-medium(:class="!dateTime ? 'info500--text' : 'textColorHint--text'")
                  v-icon.mr-3(small :color="!dateTime ? 'info500' : 'textColorHint'") mdi-alarm
                  | ASAP
            v-col.pl-1
              v-card.px-3.py-2(outlined :style="dateTime ? `border:2px solid var(--v-info500)` : `border:2px solid var(--v-textColorHint)`" @click="showPicker = true")
                div.button-AA-medium(:class="dateTime ? 'info500--text' : 'textColorHint--text'")
                  v-icon.mr-3(small :color="dateTime ? 'info500' : 'textColorHint'") mdi-calendar-month
                  | SCHEDULE
        div.p1.basic700--text.px-4.py-2.text-center(v-if="!showPicker") {{ selectedDateTime || '&nbsp;' }}
        div.mt-6(v-else style="border:1px solid var(--v-basic400); border-radius: 4px;")
          y-schedule-picker(v-model="dateTime" bgActive="var(--v-infoT08)" width="600px" :params="params")
          div.c1.basic700--text.px-4.py-2.text-center {{ selectedDateTime || '&nbsp;' }}
        v-btn.mt-4(color="success500" depressed height="40" @click="clickSave" :loading="isLoading" dark block)
          .button-AA-medium.basic100--text.mx-2 Save Changes

</template>

<script>
import { mapActions } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'EditDateTime',
  props: ['open', 'parentYezzaShipping'],
  data: () => ({
    isLoading: false,
    dateTime: null,
    showPicker: false,
    params: {
      timeInterval: 30,
      daysCount: 1,
      businessHour: [
        { day: 'Today', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Monday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Tuesday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Wednesday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Thursday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Friday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Saturday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
        { day: 'Sunday', hours: [{ begin: '00:00:00', end: '23:59:00' }] },
      ],
      offset: 0,
      daysOff: []
    },
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    },
    selectedDateTime () {
      if (!this.dateTime) {
        return 'As soon as possible'
      } else if (this.dateTime) {
        const [date, time] = this.dateTime.split(' ')
        return this.convertDate(date) + ', ' + this.covert24To12(time)
      }
      return null
    }
  },
  watch: {
    'yezzaShipping.delivery_at': {
      immediate: true,
      handler (val) {
        if (val) {
          this.dateTime = this.convertDateTimeZone(this.yezzaShipping.delivery_at, 'Asia/Kuala_Lumpur')
        }
      }
    }
  },
  mounted () {
    if (this.dateTime) {
      this.showPicker = true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave () {
      this.isLoading = true
      this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, { delivery_at: this.dateTime })
        .then(resp => {
          this.yezzaShipping = resp.data
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    convertDateTimeZone(value, zone) {
      if (!value) return '-'
      const date = DateTime.fromISO(value, { zone: zone })
      return `${date.toFormat('yyyy-MM-dd HH:mm:ss')}`
    },
    covert24To12 (time) { // format 08:00:00
      // Check correct time format and split into components
      time = time.split(':')[0] + ':' + time.split(':')[1]
      time = time.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]
      if (time.length > 1) { // If time format correct
        time = time.slice(1) // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
        time[0] = +time[0] % 12 || 12 // Adjust hours
      }
      return time.join('') // return adjusted time or original string
    },
    convertDate (val) {
      const today = new Date(new Date().getTime() + (0 * 24 * 60 * 60 * 1000))
      const tomorrow = new Date(new Date().getTime() + (1 * 24 * 60 * 60 * 1000))
      const todaydate = today.getFullYear() + '-' + this.addLeadingZero((today.getMonth() + 1), 2) + '-' + this.addLeadingZero(today.getDate(), 2)
      const tomorrowdate = tomorrow.getFullYear() + '-' + this.addLeadingZero((tomorrow.getMonth() + 1), 2) + '-' + this.addLeadingZero(tomorrow.getDate(), 2)
      if (val === todaydate) {
        return 'Today'
      }
      if (val === tomorrowdate) {
        return 'Tomorrow'
      }
      if (val === '') {
        return '-'
      }
      if (!val) {
        return 'Close'
      }
      const d = new Date(val)
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const newDate = days[d.getDay()] + ', ' + this.addLeadingZero(d.getDate(), 2) + ' ' + months[d.getMonth()]
      return newDate
    },
    addLeadingZero (str, count) {
      str = String(str)
      const len = str.length
      if (len < count) {
        for (let index = 0; index < count - len; index++) {
          str = '0' + str
        }
        return str
      }
      return str
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>